import React, { useState, useEffect } from 'react';
import { Row, Col } from 'react-bootstrap';

import {
  Text,
  Input,
  Select,
  StepsRegisterImport
} from 'v3/components';

import Card from 'v3/components/Card';

import { cooperplaceApi } from 'services/api';
import { useSnackbar } from 'v3/components/Snackbar';

import {
  fetchCities,
  fetchBrands,
  fetchVehicleColors,
  fetchVehiclesTypes,
  fetchBodies,
  fetchImplements,
} from 'utils/fetches';

export default function GeneralDate({
  setData,
  data,
  fildsDisabled,
  errors,
  disabled,
  frontImageCrlv
}) {

  const snackbar = useSnackbar();

  const [vehicleTypes, setVehicleTypes] = useState([]);
  const [vehicleImplementTypes, setVehicleImplementTypes] = useState([]);
  const [vehicleBodyTypes, setVehicleBodyTypes] = useState([]);
  const [colors, setColors] = useState([]);

  const [modelOptions, setModelOptions] = useState([]);

  async function fetchOptions() {
    try {
      let [vehicleTypesData, vehiclesBodyTypesData, implementsData] =
        await Promise.all([
          fetchVehiclesTypes(),
          fetchBodies(),
          fetchImplements(),
        ]);
      vehicleTypesData = vehicleTypesData.find(
        vtype => vtype?.name?.toLowerCase() === 'semi reboque'
      );

      setData({
        ...data,
        vehicleType: vehicleTypesData,
        vehicleTypeId: vehicleTypesData?.id,
      })

      setVehicleBodyTypes(vehiclesBodyTypesData);
      setVehicleImplementTypes(implementsData);
    } catch (error) {
      setVehicleTypes([]);
      setVehicleBodyTypes([]);
      setVehicleImplementTypes([]);
    }
  }

  useEffect(() => {
    fetchOptions();
    fetchVehicleColors().then(setColors);
  }, []);

  async function fetchModels(search) {
    if (data.brand?.id) {
      try {

        const { data } = await cooperplaceApi.get(`vehicles/manufacturers/${data.brand.id}/models`, {
          params: { search }
        });

        return data?.data;
      } catch (error) {
        return [];
      }
    }
    snackbar.show(<Text>Selecione uma marca primeiro</Text>, { type: `error` });
    return [];
  }

  async function handleChangeBrand(value) {
    try {
      if (value?.id) {
        const { data } = await cooperplaceApi.get(`vehicles/manufacturers/${value.id}/models`);
        const response = data?.data
        setModelOptions(response);
      } else {
        setModelOptions([]);
      }
    } catch (error) {
      if (value?.id)
        snackbar.show(<Text>Erro ao buscar modelos</Text>, { type: 'error' });
    }

    setData({ ...data, brand: value, model: null });
  }

  const hasSelectDollyImplementType =
    data?.implementType?.name === 'Dolly';

  return (
    <Card
      header={
        <Text color="#464E5F" type="header">
          Dados gerais
        </Text>
      }
      HeaderRightComponent={
        <Col>
          <StepsRegisterImport
            stepText="Importação do CRLV"
            activeStep={frontImageCrlv?.length}
            variant="light"
          />
        </Col>
      }
    >
      <Row className="form">
        <Col md={6} xs={12}>
          <Input
            label="Placa *"
            value={data?.plate}
            onChange={event => setData({ ...data, plate: event.target.value.toUpperCase() })
            }
            error={errors?.plate}
            disabled={fildsDisabled || disabled}
          />
        </Col>
        <Col md={6} xs={12}>
          <Input
            label="Renavam *"
            type="number"
            value={data?.renavam}
            onChange={event => setData({ ...data, renavam: event.target.value })}
            disabled={fildsDisabled || disabled}
            error={errors?.renavam}
          />
        </Col>
        <Col md={6} xs={12}>
          <Input
            label="Ano do modelo *"
            type='year'
            value={data?.yearModel}
            onChange={event => setData({ ...data, yearModel: event.target.value })}
            disabled={fildsDisabled || disabled}
            error={errors?.yearModel}
          />
        </Col>
        <Col md={6} xs={12}>
          <Input
            label="Ano de fabricação *"
            type='year'
            value={data?.yearManufacture}
            onChange={event => setData({ ...data, yearManufacture: event.target.value })}
            disabled={fildsDisabled || disabled}
            error={errors?.yearManufacture}
          />
        </Col>
        <Col md={6} xs={12}>
          <Input
            label="CRLV *"
            type="number"
            value={data?.crlv}
            onChange={event => setData({ ...data, crlv: event.target.value })}
            disabled={fildsDisabled || disabled}
            error={errors?.crlv}
          />
        </Col>
        <Col md={6} xs={12}>
          <Select
            label="Cor *"
            options={colors}
            getOptionLabel={option => option.name}
            getOptionValue={option => option.id}
            value={data?.color}
            onChange={value => setData({ ...data, color: value })}
            isDisabled={fildsDisabled || disabled}
            error={errors?.color}
          />
        </Col>
        <Col className="my-2" md={6} xs={12}>
          <Select
            label="Tipo do veículo *"
            options={vehicleTypes}
            isDisabled={true}
            getOptionLabel={option => option.name}
            getOptionValue={option => option.id}
            value={data?.vehicleType}
            error={errors?.vehicleType}
          />
        </Col>
        <Col md={6} xs={12} className="my-2">
          <Select
            label="Tipo de implemento *"
            options={vehicleImplementTypes}
            getOptionLabel={option => option.name}
            getOptionValue={option => option.id}
            isDisabled={disabled}
            value={data?.implementType}
            onChange={value => {
              if (value?.name === 'Dolly') {
                setData({
                  ...data,
                  implementType: value,
                  vehicleImplementTypeId: value?.id,
                  bodyType: null,
                  vehicleBodyTypeId: null,
                });
              }
              setData({
                ...data,
                implementType: value,
                vehicleImplementTypeId: value?.id,
              });
            }}
            error={errors?.implementType}
          />
        </Col>
        <Col md={6} xs={12} className="my-2">
          <Select
            label="Tipo do carroceria *"
            options={vehicleBodyTypes}
            getOptionLabel={option => option.name}
            getOptionValue={option => option.id}
            value={data?.bodyType}
            onChange={value =>
              setData({
                ...data,
                bodyType: value,
                vehicleBodyTypeId: value?.id,
              })
            }
            error={errors?.bodyType}
            isDisabled={hasSelectDollyImplementType || disabled}
          />
        </Col>
        <Col md={6} xs={12}>
          <Input
            label="Eixos *"
            type="number"
            value={data?.axis}
            onChange={event => setData({ ...data, axis: event.target.value })}
            disabled={fildsDisabled || disabled}
            error={errors?.axis}
          />
        </Col>
        <Col md={6} xs={12}>
          <Select.Async
            label="Marca *"
            onSearch={fetchBrands}
            value={data?.brand}
            onChange={handleChangeBrand}
            getOptionLabel={option => option.name}
            getOptionValue={option => option.id}
            error={errors?.brand}
            removeInputMin
            isDisabled={fildsDisabled || disabled}
          />
        </Col>
        <Col md={6} xs={12}>
          <Select.Async
            label="Modelo *"
            onSearch={fetchModels}
            value={data?.model}
            options={modelOptions}
            onChange={value => setData({ ...data, model: value })}
            getOptionLabel={option => option.name}
            getOptionValue={option => option.id}
            isDisabled={fildsDisabled || disabled}
            error={errors?.model}
          />
        </Col>
        <Col md={6} xs={12}>
          <Input
            label="Chassi *"
            value={data?.chassi}
            onChange={event => setData({ ...data, chassi: event.target.value })}
            disabled={fildsDisabled || disabled}
            error={errors?.chassi}
          />
        </Col>
        <Col md={6} className="my-2" xs={12}>
          <Input
            label="PBT (Peso bruto total) em kg *"
            type="number"
            min={0}
            value={data?.totalGrossWeight}
            onChange={event => setData({
              ...data,
              totalGrossWeight: event.target.value,
            })}
            disabled={fildsDisabled || disabled}
            error={errors?.totalGrossWeight}
          />
        </Col>
        <Col md={6} className="my-2" xs={12}>
          <Input
            label="Tara em kg *"
            type="number"
            min={0}
            value={data?.tareMass}
            onChange={event => setData({
              ...data,
              tareMass: event.target.value,
            })}
            disabled={disabled}
            error={errors?.tareMass}
          />
        </Col>
        <Col md={6} className="my-2" xs={12}>
          <Input
            label="Cubagem em m³ *"
            type="number"
            min={0}
            value={data?.cubage}
            onChange={event =>
              setData({
                ...data,
                cubage: event.target.value,
              })
            }
            placeholder="90"
            disabled={disabled}
            error={errors?.cubage}
          />
        </Col>
        <Col md={6} xs={12}>
          <Select.Async
            label="Cidade *"
            onSearch={fetchCities}
            value={data?.city}
            onChange={value => setData({ ...data, city: value })}
            getOptionLabel={option =>
              `${option.name}, ${option?.province?.uf || '--'}`
            }
            getOptionValue={option => option.id}
            isDisabled={fildsDisabled || disabled}
            error={errors?.city}
          />
        </Col>
      </Row>
    </Card>
  );
}
